// extracted by mini-css-extract-plugin
export var base = "_22-0";
export var updateBanner = "_22-1";